//

import React, { useEffect } from 'react'

import { AppForRoleAdmin } from './AppForRoleAdmin'

import { chainActions } from '@react/redux/chainSlice'
import { useOtChainState, useOtDispatch, useOtSelector } from '@react/redux/store'
import { logOT } from '@shared/loggingShared'
import { AuthProvider, useAuth } from 'react-oidc-context'
import UnconnectedApp from './UnconnectedApp'
import { Typography } from '@mui/material'
import { AppKitWrapper } from './AppKitWrapper'
import { AppForRoleLender } from './AppForRoleLender'

export function AppForLocation(): React.ReactElement {
  const {
    stageConfiguration: { domain, cognitoConfig },
  } = useOtChainState()
  const { clientId: cognitoClientId, userPoolId: cognitoUserPoolId } = cognitoConfig ?? {}

  if (location.hostname.startsWith('admin')) {
    const cognitoAuthConfig =
      cognitoClientId && cognitoUserPoolId && domain
        ? {
            authority: `https://cognito-idp.us-east-1.amazonaws.com/${cognitoUserPoolId}`,
            client_id: cognitoClientId,
            redirect_uri: `https://${domain.replace('app', 'admin')}`,
            response_type: 'code',
            scope: 'email openid',
            post_logout_redirect_uri: `https://${domain.replace('app', 'admin')}/logout.html`,
          }
        : undefined

    if (cognitoAuthConfig) {
      return (
        <AuthProvider {...cognitoAuthConfig}>
          <OdicLoginWrapper>
            <AppKitWrapper>
              <AppForRoleAdmin />
            </AppKitWrapper>
          </OdicLoginWrapper>
        </AuthProvider>
      )
    }
    return <Typography variant="h1">Configuring system</Typography>
  }

  return (
    <AppKitWrapper>
      <AppForRoleLender />
    </AppKitWrapper>
  )
}

const OdicLoginWrapper: React.FC<{ children: React.ReactNode }> = ({ children }): React.ReactElement => {
  const auth = useAuth()
  const dispatch = useOtDispatch()
  const { cognitoUser } = useOtSelector((state) => state.chainState)

  useEffect(() => {
    if (auth.isAuthenticated) {
      logOT.info(' OdicLoginWrapper auth isAuthenticated')
      if (!cognitoUser && auth.user) {
        dispatch(chainActions.odicConnect(auth.user))
      }
    } else if (auth.isLoading) {
      logOT.info(' OdicLoginWrapper auth isLoading')
    } else if (auth.error) {
      logOT.info('OdicLoginWrapper  auth error', auth.error)
    } else {
      logOT.info('OdicLoginWrapper  auth signinRedirect')
      auth
        .signinRedirect()
        .then((user) => {
          logOT.info('OdicLoginWrapper  auth Redirect done', user)
        })
        .catch((error) => {
          logOT.error('OdicLoginWrapper OdicLoginWrapper  auth Redirect error', error)
        })
    }
  }, [auth.isAuthenticated, auth.isLoading, auth.error, auth.user, cognitoUser])

  if (auth.isLoading) {
    return <div>Loading...</div>
  }

  console.log('OdicLoginWrapper auth', auth)

  if (auth.error) {
    if (location.search.includes('code=')) {
      location.href = '/'
      return <div>Redirecting...</div>
    }
    return <div>Login error... {auth.error.message}</div>
  }

  if (auth.isAuthenticated) {
    return <>{children} </>
  }
  return <UnconnectedApp />
}
